import type { Centrifuge } from "centrifuge"
import { State } from "centrifuge"
import { getAccessToken } from "@/shared/api/auth"

let centrifugeRef: Centrifuge | null = null

export function setCentrifugeTokenSyncTarget(client: Centrifuge | null): void {
  centrifugeRef = client
}

/**
 * Push latest access token (JWT) into the live Centrifuge client after API refresh.
 * Reconnects when already connected so the server sees the new connection JWT.
 */
export function applyLatestAccessTokenToCentrifugo(): void {
  const client = centrifugeRef
  if (!client) return
  const token = getAccessToken()
  if (!token) return
  client.setToken(token)
  if (client.state === State.Connected) {
    client.disconnect()
    client.connect()
  }
}
